/**
 * @author TankNee 2020-08-14
 * handwriting comments component which is powered by canvas
 */
import React from "react";
import PropTypes from "prop-types";
import CanvasDraw from "./react-canvas-draw";
import UIDs from "../../UIDs";
import { ChromePicker } from "react-color";
import { withTranslation } from "react-i18next";
//import domtoimage from "dom-to-image";
import cursor from "../../assets/img/handwriteCanvas/cursor.png"

const uid = UIDs.components.ui.handwritecanvas;

class HandWriteCanvas extends React.Component {
    state = {
        displayColorPicker: false,
        brushColor: this.props.brushColor,
    };
    render() {
        const { style, height, width, brushRadius, lazyRadius, iconStyle, /*iconColor,*/ imgSrc, saveData } = this.props;
        return (
            <div style={{ display: "flex" }}>
                <div style={{ margin:"80px 0 0 -50px",width:50 }}>
                    <div
                        style={{ ...styles.iconBg, background: "#b3efff" }}
                        title={this.props.t("clear")}
                        onClick={() => {
                            this.canvas.clear();
                        }}>
                        <img style={{ ...styles.iconDefaultStyle, ...iconStyle }} src={require("../../assets/img/handwriteCanvas/eraser.png")} alt="" />
                    </div>
                    <div
                        style={{ ...styles.iconBg, background: "#b3efff" }}
                        title={this.props.t("undo")}
                        onClick={() => {
                            this.canvas.undo();
                        }}>
                        <img style={{ ...styles.iconDefaultStyle, ...iconStyle }} src={require("../../assets/img/handwriteCanvas/undo.png")} alt="" />
                    </div>
                    <div
                        style={{ ...styles.iconBg, background: "#b3efff" }}
                        title={this.props.t("colorPicker")}
                        onClick={() => {
                            this.setState({
                                displayColorPicker: !this.state.displayColorPicker,
                            });
                        }}>
                        <img style={{ ...styles.iconDefaultStyle, ...iconStyle }} src={require("../../assets/img/handwriteCanvas/palatte.png")} alt="" />
                    </div>
                    {this.state.displayColorPicker && (
                        <div>
                            <div style={styles.mask} onMouseDown={() => this.hidePicker()}></div>
                            <div style={styles.popover}>
                                <ChromePicker
                                    color={this.state.brushColor}
                                    onChangeComplete={(color) => {
                                        this.setState({ brushColor: color.hex });
                                    }}
                                />
                            </div>
                        </div>
                    )}
                </div>
                <div onMouseDown={() => this.hidePicker()} ref={(screenshot) => (this.screenshot = screenshot)}
                    style={{ backgroundImage: `url(${imgSrc})`, backgroundRepeat: "no-repeat", backgroundSize: "contain", cursor: `url('${cursor}'), auto` }}>
                    <CanvasDraw
                        ref={(canvas) => {
                            this.canvas = canvas;
                        }}
                        style={style}
                        canvasHeight={height}
                        canvasWidth={width}
                        brushRadius={brushRadius}
                        lazyRadius={lazyRadius}
                        immediateLoading={true}
                        hideInterface
                        brushColor={this.state.brushColor}
                        saveData={saveData}
                    />
                </div>
            </div>
        );
    }

    getCanvasImage() {
        let imgSrc = this.canvas.canvas.drawing.toDataURL();
        return imgSrc;
    }

    clear() {
        this.canvas.clear();
    }

    getDrawData() {
        return this.canvas.getSaveData();
    }

    loadDrawData(drawData, immediate) {
        this.canvas.loadSaveData(drawData, immediate);
    }
    getScreenShot() {
        return {
            background: this.props.imgSrc,
            handwrite: this.getCanvasImage()
        }
    }
    hidePicker() {
        if (this.state.displayColorPicker) {
            this.setState({ displayColorPicker: false })
        }
    }
}

/**
 * convert react node to picture
 * @param {React.ReactElement} reactNode
 */
/*const convertNodeToImage = (reactNode) => {
    return domtoimage.toPng(reactNode);
};*/

const styles = {
    iconBg: {
        width: "32px",
        height: "32px",
        margin: "5px 0",
        borderRadius: "50%",
        cursor: "pointer",
    },
    iconDefaultStyle: {
        margin: "4px",
        width: "24px",
        height: "24px",
    },
    popover: {
        position: "absolute",
        zIndex: "20",
        left: -75,
    },
    mask: {
        position: "absolute",
        top: 0,
        left: -75,
        width: "100%",
        height: "100%",
        zIndex: 10,
    }
};

HandWriteCanvas.propTypes = {
    width: PropTypes.number,
    style: PropTypes.object,
    brushRadius: PropTypes.number,
    lazyRadius: PropTypes.number,
    iconStyle: PropTypes.object,
    iconColor: PropTypes.string,
    imgSrc: PropTypes.string,
    saveData: PropTypes.string,
    brushColor: PropTypes.string,
};

HandWriteCanvas.defaultProps = {
    width: 500,
    height: 500,
    style: { overflowY: "auto", background: "none" },
    brushRadius: 2,
    lazyRadius: 0,
    iconStyle: {},
    iconColor: "#0170FE",
    imgSrc: null,
    saveData: null,
    brushColor: "red",
};

export default withTranslation(uid, { withRef: true })(HandWriteCanvas);
